import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-member",
  "use": "icon-member-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-member\"><path d=\"M160 704c-35.2 0-64 28.8-64 64v41.6c0 12.8 9.6 22.4 22.4 22.4h595.2c12.8 0 22.4-9.6 22.4-22.4v-41.6c0-35.2-28.8-64-64-64h-512z m0-64h512c70.4 0 128 57.6 128 128v41.6c0 48-38.4 86.4-86.4 86.4h-595.2c-48 0-86.4-38.4-86.4-86.4v-41.6c0-70.4 57.6-128 128-128z m544-448h256c19.2 0 32 12.8 32 32s-12.8 32-32 32h-256c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 288h256c19.2 0 32 12.8 32 32s-12.8 32-32 32h-256c-19.2 0-32-12.8-32-32s12.8-32 32-32z m192 288h64c19.2 0 32 12.8 32 32s-12.8 32-32 32h-64c-19.2 0-32-12.8-32-32s12.8-32 32-32z m-560-576c-25.6 0-48 22.4-48 48v144c0 70.4 57.6 128 128 128s128-57.6 128-128v-144c0-25.6-22.4-48-48-48h-160z m0-64h156.8c64 0 112 51.2 112 112v144c0 105.6-86.4 192-192 192s-192-86.4-192-192v-144c3.2-60.8 54.4-112 115.2-112z\" fill=\"#ffffff\" p-id=\"4396\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/member.svg
// module id = /LrJ
// module chunks = 7